import React, { useEffect, useState } from "react";
import useStyles from "../../../../styles";
import {
  FormLabel,
  MenuItem,
  Select,
  Typography,
  Checkbox,
  ListItemText,
  TextField,
} from "@material-ui/core";

function Matrix({
  questiontype = "Match",

  matrixOptionsX,
  matrixOptionsY,
  setMatrixOptionsX,
  setMatrixOptionsY,

  matrixOptionsXHi,
  matrixOptionsYHi,
  setMatrixOptionsXHi,
  setMatrixOptionsYHi,

  isHindi,
}) {
  const classes = useStyles();

  const isMultiple = questiontype === "Match Matrix";

  const handleChangeX = (value, index) => {
    const newOptions = matrixOptionsX.map((option, i) =>
      i === index ? { ...option, option: value.slice(0, 1) } : option
    );
    setMatrixOptionsX(newOptions);
  };

  const handleChangeY = (value, index) => {
    let val = value;

    if (!isMultiple) {
      // ❌ Single character only
      val = val.slice(0, 1);
    }

    if (isMultiple) {
      // ✅ Multiple characters separated by comma
      val = val
        .replace(/\s+/g, "") // remove spaces
        .split(",") // split by comma
        .map((item) => item.split("")) // split each item into characters
        .flat() // flatten array
        .join(","); // re-join with commas
    }

    const newOptions = matrixOptionsY.map((option, i) =>
      i === index ? { ...option, option: val } : option
    );

    setMatrixOptionsY(newOptions);
  };
  const handleChangeXHi = (value, index) => {
    const newOptions = matrixOptionsXHi.map((option, i) =>
      i === index ? { ...option, option: value.slice(0, 1) } : option
    );
    setMatrixOptionsXHi(newOptions);
  };

  const handleChangeYHi = (value, index) => {
    let val = value;

    if (!isMultiple) {
      // ❌ Single character only
      val = val.slice(0, 1);
    }

    if (isMultiple) {
      // ✅ Multiple characters separated by comma
      val = val
        .replace(/\s+/g, "") // remove spaces
        .split(",") // split by comma
        .map((item) => item.split("")) // split each item into characters
        .flat() // flatten array
        .join(","); // re-join with commas
    }

    const newOptions = matrixOptionsYHi.map((option, i) =>
      i === index ? { ...option, option: val } : option
    );

    setMatrixOptionsYHi(newOptions);
  };

  return (
    <div
      className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
    >
      <Typography
        className={`${classes.w24} ${classes.mb1} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
        variant="h6"
        display="inline"
      >
        *Options
      </Typography>
      {isHindi ? (
        <div
          className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w75}`}
        >
          <FormLabel
            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
          >
            Options Hindi
          </FormLabel>
          {matrixOptionsXHi.map((option, index) => (
            <div
              key={index}
              style={{
                margin: 5,
                display: "flex",
                gap: 10,
                alignItems: "center",
              }}
            >
              <TextField
                value={option?.option}
                onChange={(e) => handleChangeXHi(e.target.value, index)}
                placeholder="Enter option"
                variant="outlined"
                size="small"
                inputProps={{
                  style: {
                    // textAlign: "center",
                    padding: "5px",
                    width: 100,
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 0,
                  },
                  "& input::placeholder": {
                    textAlign: "center",
                    opacity: 0.6,
                  },
                }}
              />
              <TextField
                value={matrixOptionsYHi[index]?.option}
                onChange={(e) => handleChangeYHi(e.target.value, index)}
                placeholder={"Enter Solution"}
                variant="outlined"
                size="small"
                inputProps={{
                  style: {
                    padding: "5px",
                    width: 120,
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 0,
                  },
                  "& input::placeholder": {
                    textAlign: "center",
                    opacity: 0.6,
                  },
                }}
              />
            </div>
          ))}
        </div>
      ) : (
        <div
          className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w75}`}
        >
          <FormLabel
            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
          >
            Options
          </FormLabel>
          {matrixOptionsX.map((option, index) => (
            <div
              key={index}
              style={{
                margin: 5,
                display: "flex",
                gap: 10,
                alignItems: "center",
              }}
            >
              <TextField
                value={option?.option}
                onChange={(e) => handleChangeX(e.target.value, index)}
                placeholder="Enter option"
                variant="outlined"
                size="small"
                inputProps={{
                  style: {
                    // textAlign: "center",
                    padding: "5px",
                    width: 100,
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 0,
                  },
                  "& input::placeholder": {
                    textAlign: "center",
                    opacity: 0.6,
                  },
                }}
              />
              <TextField
                value={matrixOptionsY[index]?.option}
                onChange={(e) => handleChangeY(e.target.value, index)}
                placeholder={"Enter Solution"}
                variant="outlined"
                size="small"
                inputProps={{
                  style: {
                    padding: "5px",
                    width: 120,
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 0,
                  },
                  "& input::placeholder": {
                    textAlign: "center",
                    opacity: 0.6,
                  },
                }}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Matrix;
